var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypographyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 221.939,
    height: 56,
    viewBox: "0 0 221.939 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.176,
    y1: 0.153,
    x2: 1.7,
    y2: 1.603,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d9ba7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#2b3da7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b1240"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(-80 -27.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M163.889,74.688l-.045-8.409-4.08,6.846h-1.995l-4.057-6.619v8.183h-4.148V58.821h3.694l5.576,9.157,5.44-9.157h3.695l.045,15.867Z",
    transform: "translate(1.299 -11.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M209.456,73.487h-8.931a2.5,2.5,0,0,0,1.054,1.462,3.519,3.519,0,0,0,1.961.51,4.231,4.231,0,0,0,1.53-.249,4.5,4.5,0,0,0,1.3-.816l2.266,2.358a6.673,6.673,0,0,1-5.236,1.995,8.362,8.362,0,0,1-3.785-.816,6.2,6.2,0,0,1-.136-11.062,7.737,7.737,0,0,1,6.8-.057,5.779,5.779,0,0,1,2.369,2.2,6.462,6.462,0,0,1,.873,3.412q0,.046-.068,1.065m-8.149-3.808a2.559,2.559,0,0,0-.85,1.541h5.032a2.561,2.561,0,0,0-.85-1.541,2.732,2.732,0,0,0-3.332,0",
    transform: "translate(-23.55 -15.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M237.241,66.471a6.5,6.5,0,0,1,2.414-.419v3.876a8.809,8.809,0,0,0-.975-.068,2.682,2.682,0,0,0-2.947,3.037v5.644h-4.307V66.256h4.1v1.473a4.015,4.015,0,0,1,1.712-1.258",
    transform: "translate(-42.324 -15.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M254.959,57.7a2.2,2.2,0,0,1,0-3.264,2.726,2.726,0,0,1,1.9-.657,2.82,2.82,0,0,1,1.9.624,2.012,2.012,0,0,1,.725,1.6,2.2,2.2,0,0,1-.725,1.689,3.067,3.067,0,0,1-3.808.011m-.249,2.017h4.307V72H254.71Z",
    transform: "translate(-54.478 -8.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M279.872,75.147a4.349,4.349,0,0,1-1.326.521,7.358,7.358,0,0,1-1.666.181,5.292,5.292,0,0,1-3.694-1.179,4.518,4.518,0,0,1-1.292-3.514V67.031H270.1V63.813h1.79v-3.2H276.2v3.2h2.81v3.218H276.2v4.08a1.445,1.445,0,0,0,.351,1.031,1.228,1.228,0,0,0,.94.374,2.282,2.282,0,0,0,1.315-.385Z",
    transform: "translate(-62.934 -12.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M303.122,62.289V65.78h7v3.468h-7v5.44h-4.488V58.821h12.444v3.468Z",
    transform: "translate(-78.138 -11.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M331,57.7a2.2,2.2,0,0,1,0-3.264,2.728,2.728,0,0,1,1.9-.657,2.82,2.82,0,0,1,1.9.624,2.012,2.012,0,0,1,.725,1.6,2.2,2.2,0,0,1-.725,1.689A3.067,3.067,0,0,1,331,57.7m-.249,2.017h4.307V72h-4.307Z",
    transform: "translate(-94.999 -8.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M360.592,67.411a5.493,5.493,0,0,1,1.394,4.1v7.027H357.68V72.216q0-2.516-2.018-2.516a2.3,2.3,0,0,0-1.779.725,3.114,3.114,0,0,0-.669,2.176v5.939h-4.307V66.255h4.1v1.337a4.881,4.881,0,0,1,1.723-1.145,5.845,5.845,0,0,1,2.176-.4,5.05,5.05,0,0,1,3.684,1.36",
    transform: "translate(-104.928 -15.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M397.751,56.783V73.6h-4.1V72.378a4.445,4.445,0,0,1-3.6,1.428,6.106,6.106,0,0,1-3.06-.781,5.656,5.656,0,0,1-2.187-2.233,7.371,7.371,0,0,1,0-6.7,5.593,5.593,0,0,1,2.187-2.21,6.176,6.176,0,0,1,3.06-.771,4.458,4.458,0,0,1,3.4,1.269v-5.6ZM392.787,69.6a3.061,3.061,0,0,0,.725-2.165,3.015,3.015,0,0,0-.714-2.131,2.4,2.4,0,0,0-1.847-.771,2.44,2.44,0,0,0-1.859.771,2.987,2.987,0,0,0-.725,2.131,3.061,3.061,0,0,0,.725,2.165,2.422,2.422,0,0,0,1.859.782,2.4,2.4,0,0,0,1.836-.782",
    transform: "translate(-123.624 -10.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M433.4,73.487h-8.931a2.5,2.5,0,0,0,1.054,1.462,3.52,3.52,0,0,0,1.961.51,4.235,4.235,0,0,0,1.53-.249,4.508,4.508,0,0,0,1.3-.816l2.266,2.358a6.673,6.673,0,0,1-5.236,1.995,8.362,8.362,0,0,1-3.785-.816,6.2,6.2,0,0,1-.136-11.062,7.737,7.737,0,0,1,6.8-.057,5.781,5.781,0,0,1,2.369,2.2,6.457,6.457,0,0,1,.873,3.412q0,.046-.068,1.065m-8.149-3.808a2.553,2.553,0,0,0-.85,1.541h5.032a2.565,2.565,0,0,0-.85-1.541,2.733,2.733,0,0,0-3.332,0",
    transform: "translate(-142.889 -15.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M461.188,66.471a6.5,6.5,0,0,1,2.414-.419v3.876a8.81,8.81,0,0,0-.975-.068A2.683,2.683,0,0,0,459.68,72.9v5.644h-4.306V66.256h4.1v1.473a4.012,4.012,0,0,1,1.712-1.258",
    transform: "translate(-161.663 -15.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M32.891,56V52.4H35.04a3.61,3.61,0,0,0,1.8-.482l18-10.4a3.6,3.6,0,0,0,1.8-3.12V17.6a3.6,3.6,0,0,0-1.8-3.121l-18-10.4a3.611,3.611,0,0,0-1.8-.482H32.891V0h2.15a7.226,7.226,0,0,1,3.6.964l18,10.4A7.21,7.21,0,0,1,60.251,17.6V38.4a7.2,7.2,0,0,1-3.605,6.241l-18,10.4a7.225,7.225,0,0,1-3.6.963ZM25.21,56a7.227,7.227,0,0,1-3.6-.963l-18-10.4A7.2,7.2,0,0,1,0,38.4V17.6a7.211,7.211,0,0,1,3.6-6.241l18-10.4A7.227,7.227,0,0,1,25.21,0h2.15V3.6H25.212a3.61,3.61,0,0,0-1.8.482l-18,10.4A3.606,3.606,0,0,0,3.6,17.6V38.4a3.6,3.6,0,0,0,1.8,3.12l18,10.4a3.609,3.609,0,0,0,1.8.482h2.149V56Zm8.129-25.282H26.9a9.894,9.894,0,1,1,.06-4h6.321a9.9,9.9,0,1,1,.06,4Zm2.351-2.144a7.3,7.3,0,1,0,7.3-7.3A7.312,7.312,0,0,0,35.69,28.574Zm-25.751,0a7.3,7.3,0,1,0,7.3-7.3A7.312,7.312,0,0,0,9.939,28.574Zm29.149,0a3.9,3.9,0,1,1,3.9,3.9A3.909,3.909,0,0,1,39.089,28.574Zm-25.75,0a3.9,3.9,0,1,1,3.9,3.9A3.909,3.909,0,0,1,13.338,28.574Z",
    transform: "translate(80 27.252)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypographyLogo);
export default __webpack_public_path__ + "static/media/TypographyLogo.c161f2e6a5f87946134a22e896c0ec43.svg";
export { ForwardRef as ReactComponent };